import React from "react";
import ReactPaginate from "react-paginate";
import PropTypes from "prop-types";

const CustomPagination = ({ page, totalPages, onPageChange }) => {
  return (
    <div className="pagination-wrapper">
      <ReactPaginate
        previousLabel={"←"}
        nextLabel={"→"}
        breakLabel={"..."}
        pageCount={totalPages}
        marginPagesDisplayed={1}
        pageRangeDisplayed={2}
        onPageChange={onPageChange}
        containerClassName={"pagination"}
        pageClassName={"page-item"}
        pageLinkClassName={"page-link"}
        previousClassName={"page-item nav-item"}
        previousLinkClassName={"page-link nav-link"}
        nextClassName={"page-item nav-item"}
        nextLinkClassName={"page-link nav-link"}
        breakClassName={"page-item break-item"}
        breakLinkClassName={"page-link"}
        activeClassName={"active"}
        forcePage={page}
      />
    </div>
  );
};

CustomPagination.propTypes = {
  page: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default CustomPagination;
